module.exports = __webpack_public_path__ + "static/media/upload.f63e57a1.png";